// noteService - Note management API client
// Implements US-4.3: Collaborative Notes Panel

import apiClient from '../utils/apiClient';
import { getToken } from '../utils/tokenStorage';
import { NoteData } from '../types/socket';

export interface CreateNoteResponse {
  success: boolean;
  note?: NoteData;
  error?: string;
}

export interface GetNotesResponse {
  success: boolean;
  notes?: NoteData[];
  error?: string;
}

/**
 * CREATE a new note in a workspace
 * POST /api/workspaces/:workspaceId/notes
 */
export async function createNote(
  workspaceId: string,
  content: string
): Promise<CreateNoteResponse> {
  try {
    const token = getToken();

    const response = await apiClient.post(
      `/api/workspaces/${workspaceId}/notes`,
      { content },
      {
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error('Failed to create note:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Failed to create note',
    };
  }
}

/**
 * GET all notes for a workspace
 * GET /api/workspaces/:workspaceId/notes
 */
export async function getNotes(workspaceId: string): Promise<GetNotesResponse> {
  try {
    const token = getToken();

    const response = await apiClient.get(`/api/workspaces/${workspaceId}/notes`, {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });

    return response.data;
  } catch (error: any) {
    console.error('Failed to fetch notes:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Failed to fetch notes',
    };
  }
}
